export default __webpack_public_path__ + "static/media/logo_nodeJS.e7ae8a1a.svg";